(function (root) {
  const copy = value => JSON.parse(JSON.stringify(value));
  const approvedEligibleVariantIds = Object.freeze(["41714345214000","41714345246768","42246997016624","42455290937392","42506460463152","42928488415280","42928488448048","42928491757616","42928491790384","42928552706096","42928552738864","42928554213424","42928554246192","42977100595248","42977434599472","42977512128560","42977570881584","42978360655920","42978602582064","42979094265904","42998890201136","42999634690096","42999634722864","41141533474864","41589961949232","41589980332080","41589980364848","41147908194352","41501372317744","42219778179120","42219778211888","41793902805040"]);
  const approvedFloorBps = Object.freeze({"41714345214000":1500,"41714345246768":1500,"42246997016624":1500,"42455290937392":1500,"42506460463152":1500,"42977100595248":1500,"42977434599472":1500,"42977512128560":1500,"42977570881584":1500,"42978360655920":1500,"42978602582064":1500,"42979094265904":1500,"42998890201136":1500,"42999634690096":1500,"42999634722864":1500,"41141533474864":1500,"41589961949232":1500,"41589980332080":1500,"41589980364848":1500,"41147908194352":1500,"41501372317744":1500,"42219778179120":1500,"42219778211888":1500,"41793902805040":1500});
  const campaignStartsAt = 1791388800000;
  const campaignEndsAt = 1791820740000;
  const tierRuleIds = Object.freeze(['1489041489968', '1489041522736', '1489041555504']);
  const capRuleIds = Object.freeze(['143949872', '143982640', '144015408', '144048176']);
  // Target identities are routed while OFF; native evidence remains empty until separately reviewed.
  const publicBindings = Object.freeze({
    PUBLIC_CANDIDATE: Object.freeze({ themeId: '166484312112', themeRole: 'unpublished', evidenceSha256: '61e8a1c4b8ce2878ad128ec6bc73b7b0cbb556010f98ad45073a0c74366a0b00' }),
    PUBLIC: Object.freeze({ themeId: '166486736944', themeRole: 'main', evidenceSha256: '7be3dddac9501eaebe710910c952aba7b76f1be287bacb4fad263eb3200fa402' })
  });
  const sameIds = (actual, expected) => Array.isArray(actual) && JSON.stringify(actual) === JSON.stringify(expected);
  const sameFloors = actual => actual && typeof actual === 'object' &&
    Object.keys(actual).length === Object.keys(approvedFloorBps).length &&
    Object.entries(approvedFloorBps).every(([variantId, bps]) => actual[variantId] === bps);
  const sha256 = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
  const storefrontPage = context => {
    const path = context?.path, type = context?.pageType;
    if (path === '/') return type === 'index';
    if (path === '/cart') return type === 'cart';
    if (path === '/search') return type === 'search';
    if (typeof path !== 'string') return false;
    if (/^\/products\/[A-Za-z0-9._~-]+\/?$/.test(path)) return type === 'product';
    if (/^\/collections\/[A-Za-z0-9._~-]+(?:\/products\/[A-Za-z0-9._~-]+)?\/?$/.test(path))
      return type === 'collection' || type === 'product';
    if (/^\/pages\/[A-Za-z0-9._~-]+\/?$/.test(path)) return type === 'page';
    if (/^\/blogs\/[A-Za-z0-9._~-]+(?:\/[A-Za-z0-9._~-]+)?\/?$/.test(path))
      return type === 'blog' || type === 'article';
    return false;
  };
  const commonContract = configuration => configuration?.id === 'THEMAN-002-1010' &&
    configuration.revision === '2026-10-08.4-mixed-32' && configuration.currency === 'PHP' &&
    configuration.startsAt === campaignStartsAt && configuration.endsAt === campaignEndsAt &&
    sameIds(configuration.eligibleVariantIds, approvedEligibleVariantIds) && sameFloors(configuration.floorBps) &&
    String(configuration.sampleVariantId) === '43326220763184' && configuration.sampleUnitCharge === 10;
  function verifyPublicProof(configuration, bindings = publicBindings, now = Date.now()) {
    const proof = configuration?.serverConfiguration;
    const context = configuration?.publicContext;
    const binding = bindings?.[proof?.scope];
    const candidate = proof?.scope === 'PUBLIC_CANDIDATE';
    const publicScope = proof?.scope === 'PUBLIC';
    if ((!candidate && !publicScope) || !binding || !commonContract(configuration) || proof.accepted !== true ||
        !sha256(binding.evidenceSha256) || proof.evidenceSha256 !== binding.evidenceSha256 ||
        proof.evidenceId !== binding.evidenceSha256 ||
        !binding.themeId || !binding.themeRole || proof.themeId !== binding.themeId ||
        proof.themeRole !== binding.themeRole || context?.themeId !== binding.themeId ||
        context.themeRole !== binding.themeRole || !storefrontPage(context) ||
        context.designMode !== false || proof.revision !== configuration.revision ||
        proof.ruleId !== tierRuleIds[0] || !sameIds(proof.tierRuleIds, tierRuleIds) ||
        !sameIds(proof.capRuleIds, capRuleIds) || proof.eligibleVariantCount !== 32 ||
        proof.eligibilityEvidenceSha256 !== '6d8b792c6f5f50a785f804062047cb5adbfc5ae5df7d0255db200d1dbcb9085b' ||
        String(proof.sampleVariantId) !== '43326220763184' || proof.sampleUnitCharge !== 10 ||
        proof.startsAt !== campaignStartsAt || proof.endsAt !== campaignEndsAt ||
        !Number.isSafeInteger(now) || now < campaignStartsAt || now >= campaignEndsAt) return false;
    if (candidate) return Number.isSafeInteger(proof.windowStartsAt) &&
      Number.isSafeInteger(proof.windowEndsAt) && proof.windowStartsAt >= campaignStartsAt &&
      proof.windowEndsAt <= campaignEndsAt && proof.windowEndsAt > proof.windowStartsAt &&
      proof.windowEndsAt - proof.windowStartsAt <= 20 * 60 * 1000 &&
      now >= proof.windowStartsAt && now < proof.windowEndsAt;
    return proof.windowStartsAt == null && proof.windowEndsAt == null;
  }
  function verifyTestProof(configuration, now = Date.now()) {
    const proof = configuration?.serverConfiguration;
    const context = configuration?.testContext;
    const windowValid = Number.isSafeInteger(proof?.windowStartsAt) &&
      Number.isSafeInteger(proof?.windowEndsAt) && proof.windowStartsAt >= campaignStartsAt &&
      proof.windowEndsAt <= campaignEndsAt && proof.windowEndsAt > proof.windowStartsAt &&
      proof.windowEndsAt - proof.windowStartsAt <= 20 * 60 * 1000;
    return commonContract(configuration) && proof?.scope === 'TEST_SCOPE' && proof.accepted === true &&
      proof.revision === configuration.revision && proof.ruleId === tierRuleIds[0] &&
      proof.evidenceId === '0bba38ee9bce102457fdfaa117440b758e1dce4508cd39acb22514cb7aa139a5' &&
      sha256(proof.currentEvidenceId) && proof.currentEvidenceId !== proof.evidenceId &&
      proof.themeId === '166484934704' && proof.testCustomerId === '10210350727216' &&
      proof.eligibilityEvidenceSha256 === '6d8b792c6f5f50a785f804062047cb5adbfc5ae5df7d0255db200d1dbcb9085b' &&
      proof.eligibleVariantCount === 32 && sameIds(proof.tierRuleIds, tierRuleIds) &&
      sameIds(proof.capRuleIds, capRuleIds) && context?.themeId === proof.themeId &&
      context.themeRole === 'development' && context.customerId === proof.testCustomerId &&
      context.designMode === false && storefrontPage(context) && windowValid &&
      now >= proof.windowStartsAt && now < proof.windowEndsAt;
  }
  function create({ campaign, adapter, coordinator, enabled = false, active = () => true, readSample = null,
    testWindowEndsAt = null, scope = null, activeUntil = null, proofIdentity = null }) {
    const requireEnabled = () => { if (!enabled) throw new Error('CAMPAIGN_TRANSFER_DISABLED'); };
    const requireActive = () => {
      requireEnabled();
      if (!active()) throw new Error('TEST_SCOPE_EXPIRED');
    };
    const milestones = () => {
      requireActive();
      const tiers = campaign.milestones();
      return { tiers: tiers.map(({ min, bps }) => ({ min, bps })), next: tiers[0], upcomingGifts: [] };
    };
    const gift = (sample, quantity) => ({ quantity, title: sample.title || 'Assorted 2ml sample', size: '2ml',
      image: sample.image || '', unitCharge: campaign.config.sampleUnitCharge });
    return Object.freeze({ version: 3, enabled, campaignId: campaign.config.id, revision: campaign.config.revision,
      testWindowEndsAt, scope, activeUntil, proofIdentity, isActiveHere: () => active(),
      pending: () => coordinator.pending(),
      milestones,
      async previewMilestones(includeSamples = true) {
        const preview = milestones();
        if (!includeSamples || typeof readSample !== 'function') return preview;
        let sample;
        try {
          sample = await readSample();
        } catch (_) { return preview; }
        requireActive();
        if (String(sample?.id) !== String(campaign.config.sampleVariantId) ||
            sample.price !== campaign.config.sampleUnitCharge || sample.available !== true ||
            (sample.stock !== null && (!Number.isSafeInteger(sample.stock) || sample.stock < preview.next.samples))) return preview;
        return { ...preview, upcomingGifts: [gift(sample, preview.next.samples)] };
      },
      async prepare(input) {
        requireActive();
        const consent = await adapter.prepare(input);
        const subtotal = consent.selectionSubtotal, discount = consent.selectionDiscount;
        const selectionTotal = subtotal - discount + consent.additionalSampleCharge;
        if (![subtotal, discount, selectionTotal, consent.existingUplift, consent.cartTotalBefore, consent.estimatedBagTotal].every(Number.isSafeInteger) ||
            subtotal < 0 || discount < 0 || selectionTotal < 0 || consent.existingUplift < 0 ||
            selectionTotal - consent.existingUplift !== consent.incrementalBagCharge ||
            consent.cartTotalBefore + consent.incrementalBagCharge !== consent.estimatedBagTotal)
          throw new Error('INVALID_BAG_ESTIMATE');
        const sample = consent.merchandise?._sample || {};
        const next = campaign.milestones()
          .find(item => item.min > consent.eligibleCount);
        const upcoming = consent.includeSamples && next && sample.available === true && sample.price === 10
          ? Math.max(0, next.samples - Math.max(consent.existingSampleQuantity, consent.sampleCap)) : 0;
        const availableUpcoming = sample.stock === null || sample.stock >= consent.existingSampleQuantity + upcoming;
        return { status: 'estimated', consent: copy(consent), subtotal, discount,
          total: selectionTotal, selectionTotal, existingUplift: consent.existingUplift,
          cartTotalBefore: consent.cartTotalBefore, incrementalBagCharge: consent.incrementalBagCharge,
          estimatedBagTotal: consent.estimatedBagTotal, sampleCharge: consent.additionalSampleCharge,
          tiers: campaign.milestones().map(({ min, bps }) => ({ min, bps })),
          eligibleCount: consent.eligibleCount, sampleQuantity: consent.sampleQuantityToAdd,
          gifts: consent.includeSamples && consent.sampleQuantityToAdd ? [gift(sample, consent.sampleQuantityToAdd)] : [],
          upcomingGifts: upcoming && availableUpcoming ? [gift(sample, upcoming)] : [],
          progress: { eligibleCount: consent.eligibleCount, earnedSamples: consent.includeSamples ? consent.sampleCap : 0,
            existingSamples: consent.existingSampleQuantity, nextMin: next?.min || null },
          currency: consent.currency, expiresAt: consent.expiresAt };
      },
      async transfer(prepared) {
        requireActive();
        if (prepared?.status !== 'estimated' || !prepared.consent) throw new Error('REVIEW_REQUIRED');
        const consent = copy(prepared.consent);
        return adapter.transfer({ lines: consent.selection, currency: consent.currency, consent, guard: active });
      },
      async decreaseWithinLock(input) {
        const guard = () => {
          requireActive();
          if (!coordinator.crossTab || !coordinator.journalReady?.()) throw new Error('CART_RECOVERY_UNAVAILABLE');
        };
        try { guard(); }
        catch (_) { return { ok: false, code: 'safe_adjustment_unavailable',
          message: 'Could not safely adjust your sample gifts. Review your bag before reducing bottles.' }; }
        return adapter.decreaseWithinLock({ ...input, guard });
      },
      async recover() { requireEnabled(); return adapter.recover(); },
      async reviewRecovery() { requireEnabled(); return adapter.reviewRecovery(); },
      async resolveReviewed(snapshot) { requireEnabled(); return adapter.resolveReviewed(snapshot); }
    });
  }
  async function readSelectionFromSection(section, lines, currency) {
    const url = new URL(root.location.href);
    url.hash = ''; url.searchParams.delete('sections'); url.searchParams.set('section_id', section.dataset.section);
    const response = await root.fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('SELECTION_READBACK_UNAVAILABLE');
    const document = new root.DOMParser().parseFromString(await response.text(), 'text/html');
    const rendered = [...document.querySelectorAll('tm-bundle-builder')].find(node => node.dataset.section === section.dataset.section);
    if (!rendered || rendered.dataset.currency !== currency) throw new Error('SELECTION_CURRENCY_CHANGED');
    const variants = new Map();
    rendered.querySelectorAll('[data-product-json]').forEach(node => JSON.parse(node.textContent).variants.forEach(item => variants.set(String(item.id), item)));
    const selection = Object.fromEntries(lines.map(({ id }) => {
      const item = variants.get(String(id));
      if (!item) throw new Error('SELECTION_UNAVAILABLE');
      return [String(id), { price: item.price, available: item.available, stock: item.stock, rule: item.rule }];
    }));
    selection._sample = JSON.parse(document.querySelector('[data-tm-bb-sample-json]')?.textContent || 'null');
    return selection;
  }
  function install(configuration, section) {
    if (!configuration?.enabled) return null;
    const proof = configuration.serverConfiguration;
    if (!proof || proof.revision !== configuration.revision || !proof.ruleId || !proof.evidenceId || proof.accepted !== true) throw new Error('SERVER_CONFIGURATION_UNVERIFIED');
    const testScope = proof.scope === 'TEST_SCOPE';
    const publicScope = proof.scope === 'PUBLIC' || proof.scope === 'PUBLIC_CANDIDATE';
    if (testScope ? !verifyTestProof(configuration) : !publicScope || !verifyPublicProof(configuration))
      throw new Error(testScope ? 'TEST_SCOPE_UNVERIFIED' : 'PUBLIC_SCOPE_UNVERIFIED');
    const context = testScope ? configuration.testContext : configuration.publicContext;
    const activeUntil = testScope || proof.scope === 'PUBLIC_CANDIDATE' ? proof.windowEndsAt : campaignEndsAt;
    const proofIdentity = JSON.stringify([configuration.id, configuration.revision, proof.scope, proof, context]);
    if (root.TheManBundleProvider) {
      if (root.TheManBundleProvider.campaignId !== configuration.id || root.TheManBundleProvider.revision !== configuration.revision ||
          root.TheManBundleProvider.scope !== proof.scope || root.TheManBundleProvider.activeUntil !== activeUntil ||
          root.TheManBundleProvider.proofIdentity !== proofIdentity) throw new Error('CAMPAIGN_CONFIGURATION_CHANGED');
      return root.TheManBundleProvider;
    }
    const coordinator = root.TheManCartCoordinator;
    if (!coordinator?.crossTab) {
      if (coordinator?.pending()) throw Object.assign(new Error('REVIEW_PENDING_CART_OPERATION'), { uncertain: true });
      return null;
    }
    const campaign = root.TheManBundleCampaign.create({ ...configuration, endsAt: activeUntil });
    const adapter = root.TheManBundleCart.create({ campaign, coordinator, enabled: true, validateExistingOffer: true,
      readSelection: (lines, currency) => {
        if (!section) throw new Error('SELECTION_UNAVAILABLE');
        return readSelectionFromSection(section, lines, currency);
      } });
    const activeHere = () => {
      if (root.location?.pathname !== context.path || Date.now() >= activeUntil ||
          !(testScope ? verifyTestProof(configuration) : verifyPublicProof(configuration))) return false;
      try {
        const current = JSON.parse(root.document.querySelector('[data-tm-bb-campaign-configuration]')?.textContent || 'null');
        return current?.enabled === true && current.id === configuration.id && current.revision === configuration.revision &&
          current.currency === configuration.currency &&
          JSON.stringify([current.id, current.revision, current.serverConfiguration?.scope, current.serverConfiguration,
            testScope ? current.testContext : current.publicContext]) === proofIdentity;
      } catch (_) { return false; }
    };
    const provider = create({ campaign, adapter, coordinator, enabled: true,
      testWindowEndsAt: testScope ? proof.windowEndsAt : null, scope: proof.scope, activeUntil,
      proofIdentity, active: activeHere,
      readSample: section ? async () => (await readSelectionFromSection(section, [], configuration.currency))._sample : null });
    adapter.connect(activeHere);
    root.TheManBundleProvider = provider;
    return provider;
  }
  const api = { version: 3, create, install, readSelectionFromSection, verifyPublicProof,
    configuration: Object.freeze({ enabled: false }) };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.TheManBundleProviderFactory ||= api;
    // The Builder installs with its section data; ordinary storefront pages only
    // need the guarded cart-decrease transaction and must not duplicate it.
    if (!root.document.querySelector('tm-bundle-builder')) {
      try {
        const configuration = JSON.parse(root.document.querySelector('[data-tm-bb-campaign-configuration]')?.textContent || 'null');
        api.install(configuration, null);
      } catch (_) { /* An unavailable proof leaves paid decreases guarded by the cart UI. */ }
    }
  }
})(typeof window === 'object' ? window : globalThis);
